<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="toc-title"><b>Contents</b></p>
<p class="toc1"><a href="#/xhtml/07_List_of_Photographs">List of Photographs</a></p>
<p class="toc1"><a href="#/xhtml/08_List_of_Maps">List of Maps</a></p>
<p class="toc1"><a href="#/xhtml/09_Introductory_Notes">Introductory Notes</a></p>
<p class="toc1"><a href="#/xhtml/10_Glossary">Glossary</a></p>
<p class="toc1a"><a href="#/xhtml/11_Chapter01">1.    The <i>Waffen SS</i> Volunteer</a></p>
<p class="toc1"><span href="#/xhtml/12_Chapter02" title="Link target outside of Sample">2.    The Greifenberg Base</span></p>
<p class="toc1"><span href="#/xhtml/13_Chapter03" title="Link target outside of Sample">3.    The Battle of Körlin</span></p>
<p class="toc1"><span href="#/xhtml/14_Chapter04" title="Link target outside of Sample">4.    The Siege of Kolberg</span></p>
<p class="toc1"><span href="#/xhtml/15_Chapter05" title="Link target outside of Sample">5.    Escape to the West</span></p>
<p class="toc1"><span href="#/xhtml/16_Chapter06" title="Link target outside of Sample">6.    Trials and Tribulations</span></p>
<p class="toc1"><span href="#/xhtml/17_Chapter07" title="Link target outside of Sample">7.    Vietnam</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Contents.vue?c48f45da